import { getCookieValue } from 'dibs-consented-storage';
import { COOKIE_KEYS } from './constants.ts';
import { type Cookie } from './types.ts';

export const getDeviceId = (cookie: Cookie): string | null =>
    getCookieValue(cookie, COOKIE_KEYS.DEVICE_ID);
